((window, document) => {
  const API_URI = 'https://js-api.scdn5.secure.raxcdn.com/dealers.jsonp';
  const API_KEY = '06b875770769debf92e44c77dc7696df7e9d00b4';
  const API_CB = 'judgeServiceCallback';
  /**
   * Construct a url for the API call
   * @param {Object} params The params to be added on the url:
   *                 secondaryCategory,
   *                 primaryCategory,
   *                 limit,
   *                 recommendationSurveyId,
   *                 surveyId
   */

  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth();
  const currentDate = new Date().getDate() + 1;
  function urlConstruct(params) {
    // set date to be 3 months to limit to recent results
    const d = new Date(currentYear, currentMonth, 2);
    const dateTo = new Date(currentYear, currentMonth, currentDate);
    d.setMonth(d.getMonth() - 2);
    dateTo.setMonth(dateTo.getMonth());
    const jsApiDate = `${d.toISOString().slice(0, 10)}%2000:00:00`;
    const jsApiDateto = `${dateTo.toISOString().slice(0, 10)}%0000:00:00`;
    const isVertuHondaBikes = window.location.href.includes('vertu-honda-bikes')
      ? 'recommendationSurveyId=220&'
      : '';
    let url = `${API_URI}?key=${API_KEY}&includeRecommendation=true&${isVertuHondaBikes}recommendationDateFrom=${jsApiDate}&recommendationDateTo=${jsApiDateto}&callback=${API_CB}`;
    Object.keys(params).forEach((key) => {
      if (params[key]) {
        url += `&${key}=${params[key]}`;
      }
    });
    return url;
  }

  // This can be outsite the initialize function as they are general utility functions.
  function checkHostname(brand) {
    return window.location.hostname.includes(brand);
  }
  function checkhref(brand) {
    return window.location.href.includes(brand);
  }
  function checkPath(brand) {
    return window.location.pathname === brand;
  }
  function initialize() {
    const manufacturerList = [
      'Audi',
      'Citroen',
      'Dacia',
      'Ford',
      'Honda',
      'Hyundai',
      'Infiniti',
      'Jeep',
      'Kia',
      'Mazda',
      'Mitsubishi',
      'Nissan',
      'Peugeot',
      'Renault',
      'SEAT',
      'Skoda',
      'Toyota',
      'Suzuki',
      'Vauxhall',
      'Versa',
      'Volvo',
    ];
    const JLRUriString = urlConstruct({
      recommendationSurveyId: 2,
      surveyId: 2,
      primaryCategory: 'JLR',
      secondaryCategory: 'Land+Rover|Jaguar',
    });
    let uriString = urlConstruct({
      limit: 1000,
    });

    function printJudgeService(data, k, dealerSpan) {
      dealerSpan = `jsRating${data.dealers[k].id}`;
      // const dealerSpanId = `#jsRating${data.dealers[k].id}`;
      const parentId = `jsStar${data.dealers[k].id}`;
      const starWidth = `#jsStar${data.dealers[k].id} .rating__star--front`;
      const jsDealerPC = `jsDealerPC${data.dealers[k].id}`;
      if (document.getElementById(dealerSpan) !== null) {
        const percent = Math.round(data.dealers[k].recommend_percent);
        if (percent > 75) {
          document.getElementById(dealerSpan).innerHTML =
            `${percent.toString()}% of customers recommend us to friends or family`;
          // only print the star if we have a rating
          document.querySelector(starWidth).style.width = `${data.dealers[k].recommend_percent}%`;
        } else {
          // our rating is below 75%, we do not want this shown
          document.getElementById(dealerSpan).innerHTML = 'Rating coming soon';
        }
        if (document.getElementsByClassName(jsDealerPC)[0]) {
          const dealers = document.getElementsByClassName(jsDealerPC);
          Object.keys(dealers).forEach((dealer) => {
            if (Object.prototype.hasOwnProperty.call(dealers, dealer)) {
              dealer.innerHTML = `${percent.toString()}% of customers would<br/>recommend `;
            }
          });
        }
        // document.getElementById(parentId).parentNode.style.display = 'inline-block';
        document.getElementById(parentId).style.display = 'inline-block';
        if (document.getElementById(dealerSpan).closest('.js-star-rating__footer')) {
          document
            .getElementById(dealerSpan)
            .closest('.js-star-rating__footer')
            .classList.remove('hide__default');
          // eslint-disable-next-line max-len
          // document.getElementById(dealerSpan).parentElement.className = document.getElementById(dealerSpan).parentElement.className.replace(/\bhide__default\b/g, '');
        }
      }
    }
    function getAlternateCategory() {
      switch (true) {
        // Us the check href function to check the URL
        case checkhref('dacia'):
          return 'renault';
        case checkhref('chingford'):
          return 'vauxhall';
        case checkhref('honda-bradford'):
          return 'Honda';
        case checkhref('nissan-bradford'):
          return 'Nissan';
        case checkhref('renault-bradford'):
          return 'renault';
        case checkhref('kia-bradford'):
          return 'kia';
        case checkhref('peugeot-oxford'):
          return 'peugeot';
        case checkhref('volkswagen-hereford'):
          return 'volkswagen';
        case checkhref('vertu-honda-bikes-grantham'):
          return 'Honda';

        default:
          return '';
      }
    }
    // Check whether the href meets any of the conditions
    const isAlternateDealership =
      checkhref('dacia') ||
      checkhref('vertu-honda-bikes-grantham') ||
      checkhref('volkswagen-hereford') ||
      checkhref('peugeot-oxford') ||
      checkhref('renault-bradford') ||
      checkhref('kia-bradford') ||
      checkhref('chingford') ||
      checkhref('honda-bradford') ||
      checkhref('nissan-bradford');
    // Then in the main URL contructor function
    manufacturerList.some((manufacturer) => {
      const lcaseDealer = manufacturer.toLowerCase();
      if (checkHostname(lcaseDealer) || window.location.pathname.includes(lcaseDealer)) {
        uriString = urlConstruct({
          limit: 1000,
          secondaryCategory: isAlternateDealership ? getAlternateCategory() : manufacturer,
        });
        return true;
      }
      return false;
    });

    function attatchScript(uriString) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = uriString;
      document.body.appendChild(script);
    }

    function injectRatings(data, jlrData) {
      // data = JSON.parse(data.substr(11, data.length - 13));
      const jlrDealerships = [
        '745',
        '893',
        '1938',
        '848',
        '544',
        '622',
        '884',
        '623',
        '624',
        '685',
        '1978',
      ];
      const dealerSpan = '';
      Object.keys(data.dealers).forEach((k) => {
        if ((!jlrData && jlrDealerships.indexOf(data.dealers[k].id) < 0) || jlrData) {
          printJudgeService(data, k, dealerSpan);
        } else if (window.location.pathname !== '/find-a-dealer/') {
          // if we are on find a dealer this overwrites the rating with the wrong one
          printJudgeService(data, k, dealerSpan);
        }
      });
    }

    // Will set the jlrSite to true if it the find-a-dealer-page on bristolstreet or macklin.
    const isBsmMMFindADealerPage =
      (checkHostname('bristolstreet') || checkHostname('macklin')) && checkPath('find-a-dealer');
    const isFarnemJLR =
      checkhref('land-rover') || checkhref('jaguar') || checkhref('our-locations');
    window.judgeServiceCallback = (data) => {
      injectRatings(data, false);
    };
    // If we are on JLR website do a request to JRL only dataset
    attatchScript(isFarnemJLR && !isBsmMMFindADealerPage ? JLRUriString : uriString);
    // If we are on BSM/MM find a dealer page get JLR dataset as well
    if (isBsmMMFindADealerPage) {
      attatchScript(JLRUriString, true);
    }
  }

  initialize();
})(window, document);
